import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonPrimary from "../../../common/components/Buttons/ButtonPrimary";
import WithActions from "../../../common/components/Wrappers/WithActions";
import { ThemeContext } from 'styled-components';
import { useContext } from 'react';
import InputValidatorField from "../../../common/components/Inputs/InputValidatorField";
import { IsValidAmount } from "../../../../utils/Validators";

const InitialStatementStep = ({
    formData,
    onChange,
    onSubmit,
    onSkip,
    disabled = false,
    isLoading = false,
    isCompleted = false
}) => {
    const theme = useContext(ThemeContext);

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        if (!disabled && !isLoading) {
            onSubmit();
        }
    };

    const handleSkip = () => {
        if (!disabled && !isLoading) {
            onSkip();
        }
    };

    const hasStatement = formData.cost > 0;

    const handleHybridClick = () => {
        if (hasStatement) {
            handleSubmit();
        } else {
            handleSkip();
        }
    };

    return (
        <Box
            sx={{
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
                borderRadius: '8px',
                margin: 0,
                transition: 'all 0.3s ease',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                paddingBottom: 0,
            }}
        >
            {!disabled && (
                <>
                    {/* Scrollable middle - same flex setup as Split step; footer stays at bottom */}
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: '100%',
                                flexShrink: 0,
                            }}
                        >
                            <Box sx={{ flexShrink: 0, mb: 2 }}>
                                <Typography variant="h6" component="div">
                                    Add Initial Charge (Optional)
                                </Typography>
                            </Box>
                            <Box
                                component="form"
                                onSubmit={handleSubmit}
                                sx={{ flexShrink: 0, width: '100%' }}
                            >
                                <WithActions forceSpacing inputType="text">
                                    <InputValidatorField
                                        name="cost"
                                        label="Initial Charge"
                                        type="number"
                                        value={formData.cost || ''}
                                        handleChange={onChange}
                                        isValidInput={IsValidAmount}
                                        helperText="(Optional, max 999,999.99, 2 decimal places)"
                                        requirementsText="Optional - enter initial charge amount (max 999,999.99, up to 2 decimal places)"
                                        disabled={disabled || isLoading}
                                        InputLabelProps={{
                                            style: { color: theme.colors.borderContrast },
                                        }}
                                        InputProps={{
                                            style: { color: theme.colors.borderContrast },
                                        }}
                                        fullWidth
                                    />
                                </WithActions>
                            </Box>
                        </Box>
                    </Box>

                    {/* Footer - flexShrink 0 keeps it at bottom like Split step */}
                    <Box
                        sx={{
                            flexShrink: 0,
                            width: '100%',
                            backgroundColor: theme.colors.backgroundPrimary,
                            paddingTop: 2,
                            paddingBottom: 0,
                            borderTop: `1px solid ${(theme.colors && theme.colors.border) || 'rgba(0,0,0,0.12)'}`,
                        }}
                    >
                        <ButtonPrimary
                            onClick={handleHybridClick}
                            disabled={disabled || isLoading}
                            fullWidth
                        >
                            {hasStatement ? 'Submit' : 'Later'}
                        </ButtonPrimary>
                    </Box>
                </>
            )}
        </Box>
    );
};

export default InitialStatementStep;
